import React from 'react';
import './PreviewTagTrendKeywordTagListItem.scss';
import Img from '../../../../components/Img/Img';
import { MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT } from '../../../../constants/service/app/tagConstants';
import { setMaximumText } from '../../../../lib/common';

const PreviewTagTrendKeywordTagListItem = (props) => {
  const { tagItem } = props;

  return (
    <div className="preview-tag-trend-trend-keyword-tag-list-item">
      <Img className="tag-img" clickAble={false} src={tagItem.url ? tagItem.url : ''} />

      <div className="tag-contents">
        <div className="tag-info">
          <div className="tag-name">#{tagItem.name}</div>
          <div className="tag-news-and-views">
            <span>{setMaximumText(tagItem.newsCnt, MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT)} 소식</span>
            <div className="dot" />
            <span>{setMaximumText(tagItem.viewCnt, MAXIMUM_AMOUNT_OF_EXPOSURE_TAG_VIEW_AMOUNT)} 조회</span>
          </div>
        </div>

        <div className="following-button">팔로잉</div>
      </div>
    </div>
  );
};

export default PreviewTagTrendKeywordTagListItem;
